<script setup lang="ts">
defineProps<{
  msg: string
}>()
</script>

<template>
    404 Not Found
</template>

<style scoped>
</style>
